import { FunctionComponent } from 'react';
import styled from 'styled-components';

import InputLabel, { InputLabelProps } from '@/components/atom/form/InputLabel';
import ArrowCaret from '@/components/atom/icon/arrow/ArrowCaret';
import { DIRECTION } from '@/types/common';

export interface DropdownProps extends Pick<InputLabelProps, 'labelSpacing'> {
  id?: string;
  label?: string;
  className?: string;
  placeholder?: string;
  isOpened: boolean;
  onClickTrigger: () => void;
  placeHolderColor: string;
}

const Dropdown: FunctionComponent<DropdownProps> = ({
  id,
  label,
  labelSpacing,
  className,
  placeholder,
  isOpened,
  onClickTrigger,
  placeHolderColor = 'black',
}) => {
  return (
    <div className={className}>
      {label && <InputLabel htmlFor={id} label={label} labelSpacing={labelSpacing} onClick={onClickTrigger} />}
      <DropdownWrapper>
        <DropdownTrigger type='button' onClick={onClickTrigger} placeHolderColor={placeHolderColor}>
          {placeholder}
          <DropdownButtonChevron>
            <ArrowCaret color={placeHolderColor} direction={isOpened ? DIRECTION.TOP : DIRECTION.BOTTOM} />
          </DropdownButtonChevron>
        </DropdownTrigger>
      </DropdownWrapper>
    </div>
  );
};

export default Dropdown;

export const DropdownWrapper = styled.div`
  border-radius: 12px;

  ${({ theme }) => `
    border: 1px solid ${theme.color.gray200};
    background: ${theme.color.gray20};
  `};
`;

export const DropdownTrigger = styled.button<{ placeHolderColor: string }>`
  overflow: hidden;
  position: relative;
  display: block;
  width: 100%;
  padding: 18px 42px 18px 16px;
  border: none;
  background-color: transparent;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${({ theme, placeHolderColor }) => `
    ${theme.typography.UI16M};
    color: ${placeHolderColor};
    `};
`;

export const DropdownButtonChevron = styled.span`
  position: absolute;
  right: 16px;
`;
